'use strict';

class EndUserConfirmService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/auth_api/end_user_confirm/:token',
            { token : '@token' },
            {
                update:  { method: 'PUT', isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.EndUserConfirmService', ['ngResource'])
    .service('EndUserConfirmService', ['$resource', EndUserConfirmService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/end_user_confirm/end_user_confirm.service.js